import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterR = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M13.628 16H15.14L13.232 12.736C14.216 12.34 14.9 11.38 14.9 10.3C14.9 8.8 13.7 7.6 12.2 7.6H8.84V16H10.22V12.94H11.852L13.628 16ZM10.22 8.896H12.2C12.932 8.896 13.52 9.508 13.52 10.3C13.52 11.08 12.932 11.704 12.2 11.704H10.22V8.896Z" }),
});

export { IconCapitalLetterR };
